import { storeCreator } from '@/utils/store/store.utils';

import { PropertyChangeItem } from '../SyncUpdatesModal/SyncUpdatesModal.types';

interface State {
  pendingModal: boolean;
  activateModal: boolean;
  activateSaveModal: boolean;
  isEmptySaveModal: boolean;
  isActivatingModal: boolean;
  successfullyActivatedModal: boolean;
  successfullySavedModal: boolean;
  unableToActivateModal: boolean;
  errorText?: string;
  syncModal: boolean;
  syncModalChanges: PropertyChangeItem[];
  updatedOrgsCount: number;
  setPendingModal: (value: boolean) => void;
  setActivateModal: (value: boolean) => void;
  setActivateSaveModal: (value: boolean) => void;
  setIsEmptySaveModal: (value: boolean) => void;
  setErrorTextModal: (value?: string) => void;
  setIsActivatingModal: (value: boolean) => void;
  setSuccessfullyActivatedModal: (value: boolean) => void;
  setSuccessfullySavedModal: (value: boolean) => void;
  setUnableToActivateModal: (value: boolean) => void;
  setSyncModal: (value: boolean) => void;
  setSyncModalChanges: (changes: PropertyChangeItem[]) => void;
  setUpdatedOrgsCount: (count: number) => void;
}

const useStore = storeCreator<State>((set) => ({
  pendingModal: false,
  activateModal: false,
  isEmptySaveModal: false,
  activateSaveModal: false,
  isActivatingModal: false,
  successfullyActivatedModal: false,
  successfullySavedModal: false,
  unableToActivateModal: false,
  syncModal: false,
  syncModalChanges: [],
  updatedOrgsCount: 0,

  setPendingModal: (value: boolean) => set(() => ({
    pendingModal: value,
  })),
  setActivateModal: (value: boolean) => set(() => ({
    activateModal: value,
  })),
  setActivateSaveModal: (value: boolean) => set(() => ({
    activateSaveModal: value,
  })),
  setIsEmptySaveModal: (value: boolean) => set(() => ({
    isEmptySaveModal: value,
  })),
  setErrorTextModal: (value?: string) => set(() => ({
    errorText: value,
  })),
  setIsActivatingModal: (value: boolean) => set(() => ({
    isActivatingModal: value,
  })),
  setSuccessfullyActivatedModal: (value: boolean) => set(() => ({
    successfullyActivatedModal: value,
  })),
  setSuccessfullySavedModal: (value: boolean) => set(() => ({
    successfullySavedModal: value,
  })),
  setUnableToActivateModal: (value: boolean) => set(() => ({
    unableToActivateModal: value,
  })),
  setSyncModal: (value: boolean) => set(() => ({
    syncModal: value,
  })),
  setSyncModalChanges: (changes: PropertyChangeItem[]) => set(() => ({
    syncModalChanges: changes,
  })),
  setUpdatedOrgsCount: (count: number) => set(() => ({
    updatedOrgsCount: count,
  })),
}));
const useModalType = () => {
  const store = useStore();

  return {
    ...store,
  };
};
export default useModalType;
